<template>
  <div class="bg-yellow text-ellipsis-wrap">
    <p id="so-ellipsis-content" class="text-content f-c-midgrey f-13 f-regular m-d-0" :class="foldingClass">
      <span class="text-label f-c-black">
        {{`${labelText} `}}
      </span>
      <span class="">
        {{ contentText }}
      </span>
    </p>
    <p class="m-d-0 text-btn" v-if="showBtn">
      <span class="f-c-blue f-13 f-regular" @click="toggleFolding">
        {{ labelBtn }}
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'SOTextEllipsis',
  props: {
    textContent: {
      type: String,
      required: true,
    },
    textLabel: {
      type: String,
      default: 'Keterangan:',
    },
    lineNumbers: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      folding: false,
      btnLabel: {
        showLess: 'Lebih sedikit',
        showMore: 'Lebih banyak',
      },
      showBtn: false
    }
  },
  mounted() {
    this.init();
  },
  watch: {
    textContent: function (newContent, oldContent) {
      if (newContent !== oldContent) {
        this.init();
      }
    }
  },
  computed: {
    contentText() {
      return this.textContent.trim()
    },
    labelText() {
      return this.textLabel.trim()
    },
    labelBtn() {
      return this.folding ? this.btnLabel.showMore : this.btnLabel.showLess
    },
    foldingClass() {
      return !this.folding
        ? `line-clamp-none`
        : `line-clamp-${this.lineNumbers}`
    },
    countLineNumbers() {
      let el = document.getElementById("so-ellipsis-content")
      let divHeight = el.offsetHeight
      let lineHeight = el.style.lineHeight ? parseInt(el.style.lineHeight) : 19.5;
      let lines = divHeight / lineHeight;

      return lines;
    }
  },
  methods: {
    init() {
      if (this.countLineNumbers <= this.lineNumbers) {
        this.folding = false;
        this.showBtn = false;
      } else {
        this.folding = true;
        this.showBtn = true;
      }
    },
    toggleFolding() {
      this.folding = !this.folding
    },
  },
}
</script>

<style scoped>
.text-ellipsis-wrap {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.text-content {
}

.text-btn {
  padding-right: 8px;
  text-align: right;
  margin-top: -4px
}

.text-btn:hover {
  cursor: pointer;
}

.text-btn:active {
  --tw-text-opacity: 1;
  font-weight: 450;
  color: rgba(29, 78, 216, var(--tw-text-opacity));
}

.line-clamp-none {
  -webkit-line-clamp: unset;
}

.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

.line-clamp-4 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}

.line-clamp-5 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
}

.line-clamp-6 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6;
}
</style>
